export default "__VITE_ASSET__BGV6r2QV__"